import React, {Component} from "react";
import Dialog from '@mui/material/Dialog';
import {DialogActions, DialogTitle, FormControl, FormControlLabel, Switch, Tooltip} from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import {connect} from "react-redux";
import {FilePond, registerPlugin} from "react-filepond";
import "filepond/dist/filepond.min.css";
import {import_cluster} from "../../actions/clusters";
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import {Alert} from "@mui/lab";
import Grid from "@mui/material/Grid";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Typography from "@mui/material/Typography";
import {withRouter} from "react-router-dom";

registerPlugin(FilePondPluginFileValidateType);

class ImportDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            files: [],
            import: false,
            importing: false,
            first_line_header: true,
            append: false,
            rows_total: null,
            importable_rows: null,
            error: null,
            success: null
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    handleInit() {
        //console.log("FilePond instance has initialised", this.pond);
    }

    startImport() {
        this.setState({
            ...this.state,
            importing: true
        });
        this.props.import_cluster(this.props.cluster.id, this.state.first_line_header, this.state.append).then(res => {
            this.setState({
                ...this.state,
                import: false,
                importing: false,
                files: [],
                rows_total: null,
                importable_rows: null,
                error: null,
                success: res.data.message
            });
        }).catch(err => {
            this.setState({
                ...this.state,
                importing: false,
                error: err.response.data.error
            });
        });
    }

    render() {
        // onClose={this.props.handleClose}
        // https://pqina.nl/filepond/docs/api/instance/properties/
        let rows_total = this.state.rows_total;
        if (this.state.first_line_header) {
            rows_total--;
            if (rows_total < 0) {
                rows_total = 0;
            }
        }
        return (this.props.cluster && <Dialog open={true} onClose={this.props.handleClose}>
                <DialogTitle>Import rows into {this.props.cluster.title}</DialogTitle>
                <DialogContent style={{width: 500}}>
                    {this.state.success && <Alert
                        style={{marginBottom: 15}} onClose={() => {
                        this.setState({...this.state, success: null})
                    }}>{this.state.success}</Alert>}
                    {this.state.error && <Alert
                        style={{marginBottom: 15}} /*onClose={() => {this.setState({...this.state, error: null})}}*/
                        severity="error">{this.state.error}</Alert>}
                    <FilePond
                        allowFileTypeValidation={true}
                        acceptedFileTypes={["text/csv", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"]}
                        labelFileTypeNotAllowed="File of invalid type"
                        fileValidateTypeLabelExpectedTypes="Only .csv and .xlsx filetypes are allowed"
                        credits={false}
                        ref={ref => (this.pond = ref)}
                        files={this.state.files}
                        allowMultiple={false}
                        allowReorder={false}
                        maxFiles={1}
                        server={{
                            url: '/api/clusters/' + this.props.cluster.id + '/upload-import',
                            process: {
                                headers: {
                                    "Authorization": `Bearer ${localStorage.getItem("token")}`
                                },
                                onload: (data) => {
                                    const d = JSON.parse(data);
                                    this.setState({
                                        ...this.state,
                                        rows_total: d.rows_total,
                                        importable_rows: d.importable_rows
                                    });
                                },
                                onerror: (data) => {
                                    this.setState({
                                        ...this.state,
                                        error: JSON.parse(data).error,
                                        success: null
                                    });
                                },
                            },
                            revert: {
                                headers: {
                                    "Authorization": `Bearer ${localStorage.getItem("token")}`
                                }
                            }
                        }}
                        disabled={this.state.importing}
                        name="import_file"
                        oninit={() => this.handleInit()}
                        onupdatefiles={fileItems => {
                            // Set currently active file objects to this.state
                            this.setState({
                                ...this.state,
                                files: fileItems.map(fileItem => fileItem.file),
                                error: null
                            });
                        }}
                        onprocessfile={(error, file) => {
                            if (error === null) {
                                this.setState({
                                    ...this.state,
                                    import: true,
                                    error: null,
                                    success: null
                                });
                            }
                        }}
                        onremovefile={(error, file) => {
                            this.setState({
                                ...this.state,
                                import: false,
                                files: [],
                                rows_total: null,
                                importable_rows: null,
                                error: null
                            });
                        }}
                    />
                    <Grid container>
                        <Grid xs={6}>
                            <FormControl>
                                <FormControlLabel
                                    control={<Switch
                                        color="primary"
                                        checked={this.state.first_line_header}
                                        onChange={(e) => {
                                            this.setState({
                                                ...this.state,
                                                first_line_header: e.target.checked
                                            });
                                        }}
                                        name="first-line-header"
                                    />}
                                    label="First line as header"
                                />
                            </FormControl>
                        </Grid>
                        <Grid xs={6}>
                            <FormControl>
                                <FormControlLabel
                                    control={<Switch
                                        color="primary"
                                        checked={this.state.append}
                                        onChange={(e) => {
                                            this.setState({
                                                ...this.state,
                                                append: e.target.checked
                                            });
                                        }}
                                        name="append"
                                    />}
                                    label={<span>Append?<Tooltip
                                        title="Instead of replacing lines, lines are appended to the end"><HelpOutlineIcon
                                        style={{height: 16, color: "#ababab"}}/></Tooltip></span>}
                                />

                            </FormControl>
                        </Grid>
                    </Grid>
                    {Boolean(this.state.append) && this.state.rows_total !== null && this.state.importable_rows !== null && this.state.importable_rows !== -1 && this.state.rows_total > this.state.importable_rows &&
                        <Alert
                            style={{marginTop: 15}}
                            severity="info">Your file contains {rows_total} rows, but your plan supports only 50 rows
                            per
                            cluster. {rows_total - this.state.importable_rows} last rows will not be
                            imported.<Typography
                                style={{fontSize: "0.875rem"}}>Upgrade to <span
                                style={{fontWeight: 900, cursor: "pointer", color: "#00ff00"}}
                                onClick={() => {
                                    this.props.history.push('/premium')
                                }}>PREMIUM</span> with No Limit of Rows!</Typography></Alert>}
                    {!Boolean(this.state.append) && rows_total > 50 && !this.props.auth.user.premium && <Alert
                        style={{marginTop: 15}}
                        severity="info">Your file contains {rows_total} rows, but your plan supports only 50 rows per
                        cluster. {rows_total - 50} last rows will not be imported. <Typography
                            style={{fontSize: "0.875rem"}}>Upgrade to <span
                            style={{fontWeight: 900, cursor: "pointer", color: "#00ff00"}}
                            onClick={() => {
                                this.props.history.push('/premium')
                            }}>PREMIUM</span> with No Limit of Rows!</Typography></Alert>}

                    {!Boolean(this.state.append) && !(!this.state.import || this.state.files.length !== 1 || this.state.importable_rows === 0) &&
                        <Alert
                            style={{marginTop: 15}}
                            severity="warning">Existing rows will be replaced</Alert>}

                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose} color="primary">
                        Cancel
                    </Button>
                    {!this.props.auth.user.premium && this.state.append &&
                        <Button onClick={this.startImport.bind(this)} color="primary"
                                disabled={this.state.importing || !this.state.import || this.state.files.length !== 1 || this.state.importable_rows === 0}>
                            Import {this.state.importable_rows !== null && (Math.min(this.state.importable_rows, rows_total)) + " rows"}
                        </Button>}
                    {!this.props.auth.user.premium && !this.state.append &&
                        <Button onClick={this.startImport.bind(this)} color="primary"
                                disabled={this.state.importing || !this.state.import || this.state.files.length !== 1}>
                            Import {!(this.state.importing || !this.state.import || this.state.files.length !== 1) && (rows_total > 50 ? "50 rows" : rows_total + " rows")}
                        </Button>}
                    {this.props.auth.user.premium && <Button onClick={this.startImport.bind(this)} color="primary"
                                                             disabled={this.state.importing || !this.state.import || this.state.files.length !== 1}>
                        Import {!(this.state.importing || !this.state.import || this.state.files.length !== 1) && rows_total + " rows"}
                    </Button>}
                </DialogActions>
            </Dialog>
        );
    }
}

const mapStateToProps = state => ({
    error: state.clusters.error,
    auth: state.auth,
    clusters: state.clusters.clusters,
});
export default withRouter(connect(
    mapStateToProps,
    {import_cluster}
)(ImportDialog));
